import { Component, OnInit } from '@angular/core';
import { SingleSourceSingleValueWidget } from "../../base/SingleSourceSingleValueWidget";

@Component({
  selector: 'app-iframe-widget',
  templateUrl: './iframe-widget.component.html',
  styleUrls: ['./iframe-widget.component.css']
})
export class IFrameWidgetComponent extends SingleSourceSingleValueWidget implements OnInit {

  w: any;
  url: any;

  override ngOnInit() {
    this.w = <any>this.widget;
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.w.url);
  }
}
